// https://codepen.io/pig3onkick3r/pen/YzqqWKY?editors=1010
import domReady from '../../js/dom-ready.js';
import { nnSlideUp, nnSlideDown } from '../../js/helpers.js';

domReady(function() {
    const $accordions = document.querySelectorAll('.nn-accordion summary');

    $accordions?.forEach($el => {
        $el.addEventListener('click', accordClick);
    });
});

function accordClick(e) {
    e.preventDefault();
    console.log('accord', e.target);
    const $thisAccordion = e.target.closest('.nn-accordion');
    const $thisContent = $thisAccordion.querySelector('.nn-accordion__content');
    const animDuration = ($thisAccordion.dataset.duration) ? $thisAccordion.dataset.duration : 400;

    if ( !$thisAccordion.hasAttribute('open') ) {
        $thisAccordion.setAttribute('open', '');
        $thisAccordion.classList.add('active');
        nnSlideDown($thisContent, animDuration);
    } else {
        nnSlideUp($thisContent, animDuration);
        $thisAccordion.classList.remove('active');
        setTimeout(function() {
            $thisAccordion.removeAttribute('open');
        }, 510);
    }
}